import React, { useEffect } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../theme";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es";

const ModalCalculoDias = ({
  open,
  onClose,
  selectedUser,
  calculoData,
  setCalculoData,
  onConfirm,
  remunerado
}) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const calcularDias = (inicio, fin) => {
    if (!inicio || !fin) return 0;
    const f1 = new Date(inicio);
    const f2 = new Date(fin);
    return Math.floor((f2 - f1) / (1000 * 60 * 60 * 24)) + 1;
  };

    useEffect(() => {
      if (remunerado === "REMUNERADO") {
        // ⭐ SI ES REMUNERADO = DESCUENTO SIEMPRE 0
        setCalculoData(prev => ({
          ...prev,
          dias: calcularDias(prev.fecha_inicio, prev.fecha_fin),
          descuento: 0
        }));
        return; // ⛔ EVITA QUE SIGA Y CALCULE NORMAL
      }

      // ⭐ Si NO es remunerado o es AUSENCIA → calcular normal
      if (calculoData.fecha_inicio && calculoData.fecha_fin) {
        const dias = calcularDias(calculoData.fecha_inicio, calculoData.fecha_fin);
        const descuento = Math.round(dias * calculoData.sueldoDia);

        setCalculoData(prev => ({
          ...prev,
          dias,
          descuento
        }));
      }
    }, [calculoData.fecha_inicio, calculoData.fecha_fin, remunerado]);

    useEffect(() => {
  if (!open) {
    setCalculoData({
      fecha_inicio: "",
      fecha_fin: "",
      dias: 0,
      descuento: 0,
      sueldo: selectedUser?.sueldo || 0,
      sueldoDia: selectedUser?.sueldoDia || 0
    });
  }
}, [open, selectedUser, setCalculoData]);


  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.5)" } }}
    >
      <Box
        sx={{
          backgroundColor: colors.primary[600],
          padding: "25px",
          width: "50vh",
          borderRadius: "15px",
        }}
      >
        <Typography variant="h4" mb={2}>
          Calcular descuento por DÍAS
        </Typography>

        <Typography>Funcionario: {selectedUser?.firstname} {selectedUser?.lastname}</Typography>
        <Typography>Sueldo mensual: {calculoData.sueldo}</Typography>
        <Typography>Sueldo diario: {Math.round(calculoData.sueldoDia)}</Typography>

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <Box sx={{ display: "flex", gap: 2, mt: 2, mb: 2 }}>
                <DatePicker
                    label="Fecha inicio"
                    value={calculoData.fecha_inicio ? dayjs(calculoData.fecha_inicio) : null}
                    onChange={(newValue) =>
                        setCalculoData(prev => ({
                            ...prev,
                            fecha_inicio: newValue ? newValue.format("YYYY-MM-DD") : ""
                        }))
                }
                />

              <DatePicker
                label="Fecha fin"
                value={calculoData.fecha_fin ? dayjs(calculoData.fecha_fin) : null}
                onChange={(newValue) =>
                  setCalculoData(prev => ({
                    ...prev,
                    fecha_fin: newValue ? newValue.format("YYYY-MM-DD") : ""
                  }))
                }
                slotProps={{
                  textField: {
                    error: calculoData.fecha_inicio && calculoData.fecha_fin &&
                            dayjs(calculoData.fecha_inicio).isAfter(dayjs(calculoData.fecha_fin)),
                    helperText: calculoData.fecha_inicio && calculoData.fecha_fin &&
                            dayjs(calculoData.fecha_inicio).isAfter(dayjs(calculoData.fecha_fin))
                      ? "La fecha fin debe ser posterior a la fecha inicio"
                      : ""
                  }
                }}
              />
            </Box>
        </LocalizationProvider>
          

        <Typography sx={{ mt: 3 }}>
          Días calculados: {calculoData.dias}
        </Typography>

        <Typography sx={{ mt: 1 }}>
          Descuento total: {calculoData.descuento} Gs.
        </Typography>

        <Box mt={3} display="flex" justifyContent="space-between">
          <Button variant="contained" color="error" onClick={onClose}>
            Cancelar
          </Button>

            <Button
              variant="contained"
              color="success"
              onClick={onConfirm}
              disabled={
                !calculoData.fecha_inicio ||
                !calculoData.fecha_fin ||
                dayjs(calculoData.fecha_inicio).isAfter(dayjs(calculoData.fecha_fin))
              }
            >
              Confirmar
            </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalCalculoDias;
